import { Link, useNavigate } from "react-router-dom";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H3, P, Image } from "../../AbstractElements";
import { dynamicImage } from "../../service";
import { CreateAccount, Href } from "../../utils/Constant";
import { useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const Login = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("test123@gmail.com");
  const [password, setPassword] = useState("Test@123");
  const navigate = useNavigate();

  const SimpleLoginHandle = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (email === "test123@gmail.com" && password === "Test@123") {
      localStorage.setItem("login", JSON.stringify(true));
      navigate(`${process.env.PUBLIC_URL}/dashboard`);
    } else {
      toast.error(t("invalidCredentials"));
    }
  };

  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <Col xs="12" className="p-0">
          <div className="login-card login-dark">
            <div>
              <div>
                <Link className="logo text-center" to={Href}>
                  <Image
                    className="img-fluid for-light"
                    src={dynamicImage("dashboard-8/Linnk_Group_logo.png")}
                    alt="looginpage"
                    style={{ width: "200px", height: "auto" }}
                  />
                  <Image
                    className="img-fluid for-dark"
                    src={dynamicImage("dashboard-8/Linnk_Group_logo.png")}
                    alt="looginpage"
                    style={{ width: "200px", height: "auto" }}
                  />
                </Link>
              </div>
              <div className="login-main">
                <Form
                  className="theme-form"
                  onSubmit={(e) => SimpleLoginHandle(e)}
                >
                  <H3>{t("signInToYourAccount")}</H3>
                  <P>{t("enterEmailAndPassword")}</P>
                  <FormGroup>
                    <Label className="col-form-label">
                      {t("emailAddress")}
                    </Label>
                    <Input
                      type="email"
                      required
                      placeholder={t("emailPlaceholder")}
                      value={email}
                      name="email"
                      onChange={(event) => setEmail(event.target.value)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">{t("password")}</Label>
                    <div className="form-input position-relative">
                      <Input
                        type={show ? "text" : "password"}
                        placeholder="*********"
                        onChange={(event) => setPassword(event.target.value)}
                        value={password}
                        name="password"
                      />
                      <div className="show-hide" onClick={() => setShow(!show)}>
                        <span className="show"> </span>
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-0 form-sub-title">
                    {/* <div className="checkbox p-0">
                      <Input id="checkbox1" type="checkbox" />
                      <Label className="text-muted" htmlFor="checkbox1">
                        {t("rememberPassword")}
                      </Label>
                    </div> */}
                    <div className="d-flex justify-content-between">
                      <Link
                        to={`${process.env.PUBLIC_URL}/authentication/forgetpassword`}
                      >
                        {t("forgotPassword")}
                      </Link>
                      <Link
                        to={`${process.env.PUBLIC_URL}/authentication/otplogin`}
                      >
                        {t("loginWithOtp")}
                      </Link>
                    </div>
                    <div className="text-end mt-3">
                      <Btn color="primary" block className="w-100">
                        {t("signIn")}
                      </Btn>
                    </div>
                  </FormGroup>
                  <P className="mt-4 mb-0 text-center">
              {"Don't have account?"}<Link className="ms-2" to={`${process.env.PUBLIC_URL}/register`}>{t("Register")}</Link>
            </P>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
